export enum introductionPageAssetConfig {
    backgroundImageOfIntro = "assets/introductionPage/post_intro_bg.jpg",
    backgroundImageOfIntroPortrait = "assets/introductionPage/post_intro_bg_portrait.jpg",
    post_intro_logo = "assets/introductionPage/post_intro_logo.png",
    randomWild_sym = "assets/introductionPage/random_wild.jpg",
    wild_sym = "assets/introductionPage/wild.jpg",
    unlimitedMultiplier = "assets/introductionPage/unlimited_multiplier.png",
    giantWildTextImage = "assets/introductionPage/giant_wild_txt.png",
    randomWildTextImage = "assets/introductionPage/random_wild_txt.png",

    continueButtonOfIntro = "assets/introductionPage/post_intro_btn.json",
    backgroundBlackImageForPortrait = "assets/introductionPage/post_intro_frame.png",

}